var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckIconRounded(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 0C27.8061 0 0 27.8057 0 62C0 96.1943 27.8057 124 62 124C96.1939 124 124 96.1943 124 62C123.999 27.8061 96.1929 0 62 0ZM62 116.485C31.9387 116.485 7.51515 92.0603 7.51515 62C7.51515 31.9387 31.9397 7.51515 62 7.51515C92.0613 7.51515 116.485 31.9397 116.485 62C116.485 92.0603 92.0603 116.485 62 116.485Z",
    fill: "url(#paint0_linear_8597_40077)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9874 45.6541L52.2298 80.2238C52.0424 80.4112 51.6663 80.4112 51.4789 80.2238L37.0119 65.7568C35.5087 64.2536 33.2546 64.2536 31.7513 65.7568C30.2481 67.26 30.2481 69.5141 31.7513 71.0174L46.2183 85.4844C47.7214 86.9876 49.7883 87.9273 51.8549 87.9273C54.1091 87.9273 55.9883 87.1763 57.4916 85.4844L92.2492 50.7269C93.7524 49.2237 93.7524 46.9696 92.2492 45.4662C90.7447 43.9644 88.4893 44.1518 86.9859 45.655L86.9874 45.6541Z",
    fill: "url(#paint1_linear_8597_40077)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8597_40077",
    x1: 62,
    y1: 0,
    x2: 62,
    y2: 124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#588DFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682292,
    stopColor: "#6251E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8597_40077",
    x1: 62.0002,
    y1: 44.4293,
    x2: 62.0002,
    y2: 87.9273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#588DFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682292,
    stopColor: "#6251E5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIconRounded);
export default __webpack_public_path__ + "static/media/check-icon-rounded.da179bccd7bda97d0bd54e93870f3566.svg";
export { ForwardRef as ReactComponent };